import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, switchMap, throwError } from 'rxjs';
import { Attachment, ILead, IPendingPaymentDTO } from './shared-interface.types';
import { DateRange } from '@angular/material/datepicker';
import { environment } from 'environments/environment';
import { isArray } from 'lodash';
import { IAddOn } from './interfaces.types';
@Injectable({
    providedIn: 'root',
})
export class SharedServiceService {
    private proxyUrl = environment.baseUrl;
    public debitOrderMandateData: any;
    public customerPaymentMethod: any;
    public debitOrdersArray: any;

    public userDebitOrderDate: any;

    private Packages: any;

    constructor(private _http: HttpClient) {}

    // ---------------------------------------------------------- //
    // ===================== CUSTOMER DETAILS ====================//
    // ---------------------------------------------------------- //
    public downloadStatement(statementID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=entityaccountstatementhistory/${statementID}/pdf?extract=true`,
            { responseType: 'blob' }
        );
    }

    public emailStatement(
        entityAccountID: number,
        statementID: number,
        fromDate: any,
        toDate: any
    ) {
        const body = {
            Data: {
                FromDate: fromDate,
                ToDate: toDate,
                PreviewOnly: true,
            },
            Url:
                'endcustomer/customeraccount/' +
                entityAccountID +
                '/statement/' +
                statementID +
                '/pdf/email',
        };
        if (statementID) {
            return this._http.post(
                `${this.proxyUrl}/service`,
                body
            );
        } else {
            body.Url =
                'endcustomer/customeraccount/' +
                entityAccountID +
                '/statement/pdf/email';
            return this._http.post(
                `${this.proxyUrl}/service`,
                body
            );
        }
    }

    public getInvoiceById(id: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/invoices/${id}/pdf`,
            { responseType: 'blob' }
        );
    }

    public getCustomerInvoices() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/invoices`
        );
    }

    public getCustomerOutstandingInvoices() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/outstanding_invoices`
        );
    }

    public getCustomerStatements(entityAccountID: number, status: string) {
        return this._http.get(
            `${this.proxyUrl}/service?url=odata/entityaccountstatementhistoryodata?entityAccountID=${entityAccountID}&status=${status}`
        );
    }

    public getCustomerAccount() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/account`
        );
    }

    public getCustomerPayments() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/paymentmethods`
        );
    }

    public getCustomerBillingItems() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/allservices`
        );
    }

    public getCustomerLeads() {
        return this._http.get(`${this.proxyUrl}/service?url=endcustomer/leads`);
    }

    public getCustomerActiveServices() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/activeservices`
        );
    }

    public updateCustomerAccount(customerAccount: any) {
        const data = {
            Data: customerAccount,
            Url: 'endcustomer/account',
        };
        return this._http.put(
            `${this.proxyUrl}/service`,
            data
        );
    }

    // ---------------------------------------------------------- //
    // ===================== DEBIT ORDERS ========================//
    // ---------------------------------------------------------- //

    public changeDebitOrderDate(account: object) {
        const body = {
            Url: 'endcustomer/account',
            Data: {
                ...account,
            },
        };
        return this._http.put(`${this.proxyUrl}/service`, body);
    }

    public getDebitOrderMandateStatus(leadId: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${leadId}/debitordermandaterequired`
        );
    }

    public isDebitOrderRequired(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/debitordermandaterequired`
        );
    }

    public generateDebitOrderMandate(
        leadEntityID: number,
        entityAccountID: number,
        debitAmount: number,
        paymentMethod: any
    ) {
        if (!paymentMethod?.PaymentMethod) {
            return throwError(() => new Error('Payment method required for debit order mandate'));
        }
        const body = {
            Url: 'debitordermandate/generate?isInternal=true',
            Data: {
                LeadEntityID: leadEntityID,
                EntityAccountID: entityAccountID,
                DebitAmount: debitAmount,
                CreateDefaultPaymentMethod: true,
                DefaultPaymentMethod: {
                    PaymentMethod: paymentMethod.PaymentMethod,
                    PaymentMethodName: paymentMethod.PaymentMethodName,
                    BankAccountName: paymentMethod.BankAccountName?.slice(0, 30),
                    BankAccountType: paymentMethod.BankAccountType,
                    BankAccountTypeName: paymentMethod.BankAccountType,
                    BankAccountBranchCode: paymentMethod.BankAccountBranchCode,
                    BankAccountNumber: paymentMethod.BankAccountNumber,
                    IsDefault: true,
                    BankName: paymentMethod.BankName,
                },
            },
        };
        return this._http.post(`${this.proxyUrl}/service`, body);
    }

    public getDebitOrder(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/debitordermandates/list`
        );
    }

    public rejectDebitOrder(EntityAccountDebitOrderMandateID: number) {
        const data = {
            Url:
                'debitordermandate/' +
                EntityAccountDebitOrderMandateID +
                '/reject',
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public acceptDebitOrderOTP(EntityAccountDebitOrderMandateID: number) {
        const data = {
            Url:
                'debitordermandate/' +
                EntityAccountDebitOrderMandateID +
                '/request_otp?isInitiate=false&isAuthorise=true',
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public authoriseMandateWithOTP(
        EntityAccountDebitOrderMandateID: number,
        OTP: number
    ) {
        const data = {
            Url:
                'debitordermandate/' +
                EntityAccountDebitOrderMandateID +
                '/authorise_accept_mandate',
            Data: {
                AuthorisedOTP: OTP,
            },
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public cancelDebitOrder(LeadEntityID: number, reason: any, comment) {
        const data = {
            Url: `endcustomer/leads/${LeadEntityID}/cancel?cancellationReasonID=${reason.CancellationReasonID}&cancellationNotes=${comment}`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public getSalesItemByID(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/sales_items`
        );
    }

    // Remove Sales Item from Lead
    // DELETE entitylinkedofferable/delete/{entityLinkedOfferableEntityID}

    public removeSalesItemFromLead(entityLinkedOfferableEntityID: number) {
        return this._http.delete(
            `${this.proxyUrl}/service?url=entitylinkedofferable/delete/${entityLinkedOfferableEntityID}`
        );
    }

    // ---------------------------------------------------------- //
    // ===================== BANK DETAILS ========================//
    // ---------------------------------------------------------- //
    public getBankList() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/paymentmethods/banks`
        );
    }

    public getBankAccountTypeList() {
        return this._http.get(
            `${this.proxyUrl}/service?url=accountpaymentmethods/bankaccounttypes`
        );
    }

    public getDebitOrderCollectionRuns() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/debitordercollectionruns`
        );
    }

    // ---------------------------------------------------------- //
    // ==================== PAYMENT METHODS=======================//
    // ---------------------------------------------------------- //
    public getUpfrontAmountDue(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/upfrontpaymentamountdue`
        );
    }

    public generatePendingPayment(DTO: IPendingPaymentDTO) {
        const payload = {
            LeadEntityID: DTO.leadEntityId,
            IsPendingPayment: true,
            PendingAmount: DTO.pendingAmount,
            EntityAccountID: DTO.entityAccountId,
            Allocations: DTO.isPartialPayment
                ? DTO.partialAmount
                : DTO.pendingAmount,
            IsForCardTokenisation: DTO.isForCardTokenisation,
            AccountReceiptPaymentType: 'CreditCard',
        };

        const data = {
            Data: payload,
            Url: 'endcustomer/pending_payment',
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public getPendingPayment(LeadEntityID: IPendingPaymentDTO) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/pending_payments`
        );
    }

    public generatePaymentLinks(
        EntityAccountReceiptID: IPendingPaymentDTO,
        redirectURL: string
    ) {
        return this._http.get(
            `${this.proxyUrl}/service?url=` +
                encodeURIComponent(
                    `entityaccountreceipts/${EntityAccountReceiptID}/generate_payment_links` +
                        '?redirectUrl=' +
                        redirectURL
                )
        );
    }

    public getEntityAccountReceiptsByLeadId(leadId: number, top: number = 20, count: boolean = true) {
        return this._http.get(
            `${this.proxyUrl}/service?url=` +
                encodeURIComponent(
                    `odata/entityaccountreceiptsodata?leadId=${leadId}&$top=${top}&$count=${count}`
                )
        );
    }

    public unlinkPendingReceiptFromLead(entityAccountReceiptID: number) {
        const data = {
            Url: `entityaccountreceipts/${entityAccountReceiptID}/unlink_pending_from_lead`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public addPaymentMethods(paymentMethodPayload: any) {
        const dto = {
            Url: 'endcustomer/paymentmethods',
            Data: paymentMethodPayload,
        };
        return this._http.post(`${this.proxyUrl}/service`, dto);
    }

    public getPaymentMethods() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/paymentmethods`
        );
    }

    public previewDebitOrderMandate(
        entityAccountDebitOrderMandateID: number,
        token: string
    ) {
        return `${this.proxyUrl}/service?inlinePdf=true&url=debitordermandate/${entityAccountDebitOrderMandateID}/pdf?Token=${encodeURIComponent(token)}`;
    }

    public getDebitOrderMandatePdfBlob(
        entityAccountDebitOrderMandateID: number,
        token: string
    ) {
        const url = this.previewDebitOrderMandate(entityAccountDebitOrderMandateID, token);
        return this._http.get(url, { responseType: 'blob' });
    }

    // ---------------------------------------------------------- //
    // ==================== TICKETS=======================//
    // ---------------------------------------------------------- //

    // GET ALL TICKETS
    public getAllTickets() {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/tickets`
        );
    }

    public getTicketTopics() {
        return this._http.get(`${this.proxyUrl}/service?url=TicketTopics`);
    }

    public createTicket(ticketData: any) {
        // console.log(ticketData)
        const data = {
            Url: 'endcustomer/tickets/withoutattachments',
            Data: {
                Description: ticketData.ticketDetails,
                EmailAddress: ticketData.EmailAddress,
                MobileNumber: ticketData.MobileNumber,
                Subject: ticketData.Name,
                TopicId: ticketData.issueType.Id,
            },
        };
        // console.log(data)
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public createContactTicket(ticketData: any) {
        const data = {
            Url: `ticket?sendAutoReply=true`,
            Data: ticketData,
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public uploadFileToTicket(ticketID: number, fileObject: File) {
        return from(fileObject.arrayBuffer()).pipe(
            switchMap((buffer: ArrayBuffer) => {
                const data = {
                    Url: `endcustomer/tickets/attachfilestoticket?ticketId=${ticketID}`,
                    Data: {
                        FileName: fileObject?.name,
                        ContentType: fileObject?.type,
                        FileSize: fileObject?.size,
                        FileData: this.toBase64(buffer),
                    },
                };
                return this._http.post(`${this.proxyUrl}/service`, data);
            })
        );
    }

    private toBase64(buffer: ArrayBuffer): string {
        const bytes = new Uint8Array(buffer);

        // Chunked: spreading a multi-MB array into fromCharCode overflows the stack.
        const chunkSize = 0x8000;
        let binary = '';
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
        }

        return btoa(binary);
    }

    // GET ALL MESSAGES
    public getAllTicketMessages(id) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/tickets/externalcomments/${id}`
        );
    }

    // SEND TICKET MESSAGE
    public sendTicketMessage(ticketNumber: number, message: string) {
        const data = {
            Url: `ticket/${ticketNumber}/comment`,
            Data: {
                IsInternal: false,
                Text: message,
                TicketId: ticketNumber,
            },
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    // ---------------------------------------------------------- //
    // ======================== PACKAGES =========================//
    // ---------------------------------------------------------- //
    public getAvailablePackages(leadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/availablepackages?LeadEntityID=${leadEntityID}`
        );
    }

    public getPackageByID(PackageEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=packages/${PackageEntityID}`
        );
    }

    public getTermsAndConditions(
        leadEntityID: number,
        PackageEntityID: number
    ) {
        // return this._http.get(`${this.proxyUrl}/service?url=packages/${PackageEntityID}/termsandconditions`)
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${leadEntityID}/termsandconditions?packageIds=${PackageEntityID}`
        );
    }

    public acceptTermsAndConditions(
        LeadEntityID: number,
        TermsAndConditionsTemplateID: number
    ) {
        const data = {
            Url: 'acceptedterms',
            Data: {
                LeadEntityID: LeadEntityID,
                TermsAndConditionsTemplateID: TermsAndConditionsTemplateID,
            },
        };

        return this._http.post(
            `${this.proxyUrl}/service`,
            data
        );
    }

    public addPackageToLead(LeadEntityID: number, Package: any) {

        const data = {
            Data: {
                Packages: [{ PackageEntityID: Package }],
            },
            Url: 'lead/' + LeadEntityID + '/packages',
        };
        
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public addItemToLead(leadId: number, OfferableCode: string) {

        const data = {
            OfferableCode: OfferableCode
        };

        return this._http.post(
            `${this.proxyUrl}/lead/${leadId}/sales_items`, data
        );
    }

    

    // ---------------------------------------------------------- //
    // ======================== LEADS =========================//
    // ---------------------------------------------------------- //

    public getLeadById(LeadEntityID: any) {
        return this._http.get(`${this.proxyUrl}/lead/${LeadEntityID}`);
    }

    public getCreditVettingPrevented(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/creditvettingprevented`
        );
    }

    public removeSalesItemsFromLead(LeadEntityID: number) {
        return this._http.delete(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/remove_all_sales_items`
        );
    }

    public getLinkedOfferablesByLeadId(leadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=entitylinkedofferable/list/${leadEntityID}`
        );
    }

    public updateLead(lead: ILead) {
        return this._http.post(`${this.proxyUrl}/lead`, lead);
    }

    public creditVetting(lead: ILead) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/leads/${lead.LeadEntityID}/creditvetting`
        );
    }

    public validateAccountForVetting(accountID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=creditvetting/${accountID}/validateaccountforvetting`
        );
    }

    public generateLead(offerableID: number, type: string) {
        const dto = {
            Audit_IsActive: false,
            AutoGenerateCollaborators: true,
            Fibre_Feasibility_DoTest: true,
            IsFeasibilityLead: true,
            LeadActionTypeCode: type,
            LeadSource: 'PUBLIC',
            Microwave_Feasibility_DoTest: true,
            Mobile_Feasibility_DoTest: true,
            UpdatingEntityAccountOfferableID: offerableID,
            LeadDescription: type ? type : null,
        };
        return this._http.post(`${this.proxyUrl}/lead`, dto);
    }

    public generateAddonLead(offerableID: number, type: string) {
        const dto = {
            Audit_IsActive: false,
            AutoGenerateCollaborators: true,
            Fibre_Feasibility_DoTest: true,
            IsFeasibilityLead: false,
            LeadActionTypeCode: type,
            LeadSource: 'PUBLIC',
            Microwave_Feasibility_DoTest: true,
            Mobile_Feasibility_DoTest: true,
            UpdatingEntityAccountOfferableID: offerableID,
            LeadDescription: type ? type : null,
        };
        return this._http.post(`${this.proxyUrl}/lead`, dto);
    }

    public feasability(data: any) {
        return this._http.post(`${this.proxyUrl}/lead`, data);
    }

    public cancelLeadById(LeadEntityID: any) {
        const data = {
            Url: `lead/${LeadEntityID}/cancel`,
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public cancelLeadWithReason(
        LeadEntityID: number,
        cancellationReasonID: number,
        cancellationNotes: string
    ) {
        const encodedNotes = encodeURIComponent(cancellationNotes ?? '');
        const data = {
            Url: `endcustomer/leads/${LeadEntityID}/cancel?cancellationReasonID=${cancellationReasonID}&cancellationNotes=${encodedNotes}`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public cancelInterestLeadWithoutReason(
        LeadEntityID: number,
        cancellationNotes: string
    ) {
        const encodedNotes = encodeURIComponent(cancellationNotes ?? '');
        const data = {
            Url: `endcustomer/leads/${LeadEntityID}/cancel?cancellationNotes=${encodedNotes}`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public setLeadActionType(LeadEntityID: any, orderType: string) {
        const data = {
            Url: `lead/${LeadEntityID}/leadActionType/${orderType}`,
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public updateLeadStatus(leadEntityID: number, status: string) {
        const data = {
            Url: `lead/${leadEntityID}/status/${status}`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public getLeadMarketingSources() {
        return this._http.get(
            `${this.proxyUrl}/service?url=marketingsource/list`
        );
    }

    public updateLeadMarketingSource(LeadEntityID: number, sourceId: number) {
        const data = {
            Url: `lead/${LeadEntityID}/updatemarketingsource?marketingSourceId=${sourceId}`,
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    // ---------------------------------------------------------- //
    // ======================== Services =========================//
    // ---------------------------------------------------------- //
    public getLeadCancelationReasons() {
        return this._http.get(
            `${this.proxyUrl}/service?url=leads/cancellationreasons?context=LeadCancellation`
        );
    }

    public getServiceCancelationReasons() {
        return this._http.get(
            `${this.proxyUrl}/service?url=leads/cancellationreasons?context=ServiceCancellation`
        );
    }

    public cancelService(data: any) {
        return this._http.post(`${this.proxyUrl}/lead`, data);
    }

    // ---------------------------------------------------------- //
    // ======================== Upload Files =====================//
    // ---------------------------------------------------------- //

    public uploadFile(file: File) {
        return from(file.arrayBuffer()).pipe(
            switchMap((buffer: ArrayBuffer) => {
                const data = {
                    Url: `file/upload`,
                    Data: {
                        FileName: file?.name,
                        ContentType: file?.type,
                        FileSize: file?.size,
                        FileData: this.toBase64(buffer),
                    },
                };

                return this._http.post(`${this.proxyUrl}/service`, data);
            })
        );
    }

    public attachment(file: Attachment) {
        const data = {
            Data: {
                ...file,
            },
            Url: `attachments`,
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public getAllAttachments(entityId: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=attachments/forentity/${entityId}`
        );
    }

    /**
     * Delete an attachment by EntityAttachmentEntityID.
     * DELETE {proxyUrl}/service?url=attachments/{entityAttachmentEntityId}
     */
    public deleteAttachment(entityAttachmentEntityId: number) {
        return this._http.delete(
            `${this.proxyUrl}/service?url=attachments/${entityAttachmentEntityId}`,
            { body: {} }
        );
    }

    public getAddons(LeadEntityID: number) {
        return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/availability/addons`)
      }
    
      public addAddOnToLead(addOn: IAddOn) {
        const data = {
          Data: addOn,
          Url: `entitylinkedofferable`
        }
        return this._http.post(`${this.proxyUrl}/service`, data);
      }

      public removeAddOnFromLead(entityLinkedOfferableId: number) {
        return this._http.delete(`${this.proxyUrl}/service?url=entitylinkedofferable/${entityLinkedOfferableId}`);
      }

    // ---------------------------------------------------------- //
    // ======================== CALL ME BACK =====================//
    // ---------------------------------------------------------- //
    public requestCallBack(leadId: number) {
        const data = {
            Url: `lead/${leadId}/requestcallback`,
            Data: {},
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public requestCallBackLead(lead: ILead) {
        // console.log(lead)
        return this._http.post(`${this.proxyUrl}/lead`, lead);
    }

    // Creates a brand new Callback lead. POST /lead is an upsert on the Agility side:
    // a null/absent LeadEntityID creates, anything else updates. Never send 0 here.
    public createCallbackLead(dto: any) {
        return this._http.post(`${this.proxyUrl}/lead`, dto);
    }

    // ---------------------------------------------------------- //
    // =================Special Products========================= //
    // ---------------------------------------------------------- //

    public getSpecialProduct(EntityAccountOfferableEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/activeitems/${EntityAccountOfferableEntityID}/specialproduct/overview?callerContext=EndCustomer`
        );
    }

    public packageCompletionValidate(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/completion/validate`
        );
    }

    public executeSpecialProductAction(
        LeadEntityID: number,
        SalesEntityItemId: number,
        ActionKey: string,
        actionPayload: any
    ) {
        const data = {
            Url: `endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityItemId}/specialproduct/actions/execute?actionKey=${ActionKey}`,
            Data: actionPayload,
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public getSpecialProductOverview(
        LeadEntityID: number,
        SalesEntityId: number
    ) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityId}/specialproduct/overview?callerContext=EndCustomer`
        );
    }

    public executeSpecialProductSubActionService(
        ActiveItemId: number,
        ActionKey: string,
        SubActionKey: string,
        actionPayload: any
    ) {
        const data = {
            Url: `endcustomer/activeitems/${ActiveItemId}/specialproduct/actions/execute?actionKey=${ActionKey}/${SubActionKey}`,
            Data: actionPayload,
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }
    public executeSpecialProductSubAction(
        LeadEntityID: number,
        SalesEntityId: number,
        ActionKey: string,
        SubActionKey: string,
        actionPayload: any
    ) {
        const data = {
            Url: `endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityId}/specialproduct/actions/execute?actionKey=${ActionKey}/${SubActionKey}`,
            Data: actionPayload,
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public getSpecialProductOverviewOnService(
        entityAccountOfferableEntityID: number
    ) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/activeitems/${entityAccountOfferableEntityID}/specialproduct/overview?callerContext=EndCustomer`
        );
    }

    public executeSpecialProduct(
        entityAccountOfferableEntityID: number,
        actionKey: string
    ) {
        const data = {
            Url: `endcustomer/activeitems/${entityAccountOfferableEntityID}/specialproduct/actions/execute?actionKey=${actionKey}`,
        };
        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public requiresAddressVerification(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/requires_address_verification`
        );
    }

    public getAddressVerification(LeadEntityID: number, address: string) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/verification_addresses?search=${address}`
        );
    }

    // ---------------------------------------------------------- //
    // ======================= Channel Partner ===================//
    // ---------------------------------------------------------- //
    public channelPartnerOrder(leadID: number, detailsUpdated: boolean) {
        const data = {
            Data: {
                LeadId: leadID,
                PasswordReset: true,
                detailsUpdated,
            },
            Url: `channelpartnerorders/${leadID}`,
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public createChannelPartnerOrder(
        LeadEntityID: number,
        emailVerificationToken: string,
        emailVerified: boolean,
        leadRegistrationToken: string,
        passwordReset: boolean,
        passwordResetToken: string,
        userName: string
    ) {
        const data = {
            Data: {
                LeadId: LeadEntityID,
                EmailVerificationToken: emailVerificationToken,
                EmailVerified: emailVerified,
                LeadRegistrationToken: leadRegistrationToken,
                PasswordReset: passwordReset,
                PasswordResetToken: passwordResetToken,
                UserName: userName,
            },
            Url: 'channelpartnerorders/' + LeadEntityID,
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    public getChannelPartnerOrder(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=channelpartnerorders/${LeadEntityID}`
        );
    }

    /* -------------------------------------------------------------------------- */
    /*                              Duplicate Orders                              */
    /* -------------------------------------------------------------------------- */

    public checkForDuplicateOrderById(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/checkforduplicate`
        );
    }

    public checkCustomerDuplicateOrderById(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/lead/${LeadEntityID}/checkforduplicate`
        );
    }

    public getDuplicateOrderReasons(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=duplicateorderreasons/${LeadEntityID}/list`
        );
    }

    public updateDuplicateOrderReason(
        LeadEntityID: number,
        duplicateOrderNotes: string,
        duplicateOrderReasonID: number
    ) {
        const data = {
            Url: `lead/${LeadEntityID}/duplicateorder`,
            Data: {
                DuplicateOrderNotes: duplicateOrderNotes,
                DuplicateOrderReasonID: duplicateOrderReasonID,
            },
        };

        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public forwardCustomerRegistration(LeadEntityID: number) {
        const data = {
            Url: `lead/${LeadEntityID}/forwardforcustomerregistration`,
        }
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    /* -------------------------------------------------------------------------- */
    /*                              Quotes                                        */
    /* -------------------------------------------------------------------------- */

    /* ------------------------------- Get Quotes ------------------------------- */
    public getQuotes(LeadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${LeadEntityID}/latestapprovedquote`
        );
    }

    /* ------------------------------- Email Quote ------------------------------ */
    public emailQuote(LeadEntityID: number) {
        const data = {
            Url: `lead/${LeadEntityID}/emailquote`,
        }
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    /* -------------------------- Get Quote (Download) -------------------------- */
    public downloadQuote(QuoteID: string) {
        return this._http.get(
            `${this.proxyUrl}/service?url=accountbillrevisions/${QuoteID}/pdf`,
            { responseType: 'arraybuffer' }
        );
    }

    /* --------------------------- Upload Signed Quote -------------------------- */
    public uploadSignedQuote(
        leadEntityID: number,
        contractSignedDate: string,
        signedContractFileName: string,
        signedContractFileID: number
    ) {
        const data = {
            Url: `lead/${leadEntityID}/contractsigned`,
            Data: {
                ContractSignedDate: contractSignedDate,
                SignedContractFileName: signedContractFileName,
                SignedContractFileID: signedContractFileID,
            },
        };

        return this._http.post(`${this.proxyUrl}/service`, data);
    }

    /* ------------------------ Download Signed Contract ------------------------ */
    public downloadSignedQuote(leadEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${leadEntityID}/contractsigned`
        );
    }

    /* ------------------------------ Accept Quote ------------------------------ */
    public acceptQuote(leadEntityID: number, quoteId: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${leadEntityID}/quote/${quoteId}/accept`
        );
    }

    /* ------------------------------ Reject Quote ------------------------------ */
    public rejectQuote(leadEntityID: number, quoteId: string) {
        return this._http.get(
            `${this.proxyUrl}/service?url=lead/${leadEntityID}/quote/${quoteId}/reject`
        );
    }

    /* ------------------------------ Pending Services ------------------------------ */
    public getPendingServices(billingId: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/pendingservices/${billingId}`
        );
    }

    public cancelServiceRenewal(serviceId: number) {
        const data = {
            Url: `endcustomer/services/${serviceId}/cancelrenewal`,
        };
        return this._http.put(`${this.proxyUrl}/service`, data);
    }

    public getServiceById(EntityAccountOfferableEntityID: number) {
        return this._http.get(
            `${this.proxyUrl}/service?url=endcustomer/services/${EntityAccountOfferableEntityID}`
        );
    }
}
